<template>
    <div class="container has-text-left">
        <div class="container margin_top_1rem">
            <b-table
                    :narrowed="true"
                    :striped="true"
                    default-sort="device_name"
                    :data="topics"
            >
                <template slot-scope="props">
                    <b-table-column label="Device" field="device_name" sortable>
                        <router-link :to="{path: '/configure/devices/' + props.row.device_id}">
                            {{props.row.device_name}}
                        </router-link>
                    </b-table-column>
                    <b-table-column label="Topic" field="topic" sortable>{{props.row.topic}}</b-table-column>
                    <b-table-column v-show="topics.length > 1">
                        <div @click="handleDeleteSource(props.row.id)">
                            <b-icon type="is-danger" icon="delete" style="cursor: pointer;"></b-icon>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
            <div class="margin_top_1rem">
                <b-button v-if="!addFormVisible" type="is-primary" class="is-small"
                          @click="addFormVisible = !addFormVisible">Add source
                </b-button>
                <div class="container has-text-left" v-else>
                    <b-field label="Integration">
                        <b-select v-model="addSourceIntegrationId">
                            <option v-for="integration in optionsForIntegration"
                                    :key="integration.id"
                                    :value="integration.id"
                            >{{integration.name}}</option>
                        </b-select>
                    </b-field>
                    <b-field label="Device" v-if="addSourceIntegrationId > 0">
                        <b-select v-model="addSourceDeviceId">
                            <option
                                    v-for="device in optionsForDevice"
                                    v-bind:key="device.id"
                                    :value="device.id"
                            >{{device.name}}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field label="Topic" v-if="addSourceDeviceId > 0">
                        <b-select v-model="addSourceTopicId">
                            <option :value="0">Choose topic...</option>
                            <option
                                    v-for="deviceTopic in topicsForDevice(addSourceDeviceId)"
                                    v-bind:key="deviceTopic.id"
                                    :value="deviceTopic.id"
                            >
                                {{deviceTopic.topic}}
                            </option>
                        </b-select>
                    </b-field>
                    <div class="buttons">
                        <b-button type="is-danger-outlined" @click="handleAbort">Abort</b-button>
                        <b-button type="is-success" :disabled="!validAdd()" @click="handleAddSource"
                                  v-if="addSourceTopicId > 0">Add
                        </b-button>
                    </div>
                </div>
                <hr />
            </div>
        </div>
        <div class="container margin_top_1rem">
            <b-field label="Combine Function:">
                <b-select v-model="combineFunctionName">
                    <option
                            v-for="combineFunction in combineFunctions"
                            :key="combineFunction.name"
                            :value="combineFunction.name"
                    >{{combineFunction.name}}
                    </option>
                </b-select>
            </b-field>
        </div>
        <div class="container margin_top_1rem">
            <b-field label="Action to perform on object:">
                <b-select v-model="actionTypeId">
                    <option v-for="actionType in actionTypes"
                            v-bind:key="actionType.id"
                            :value="actionType.id"
                    >
                        {{actionType.name}}
                    </option>
                </b-select>
            </b-field>
        </div>
        <div class="container">
            <hr />
        </div>
        <div class="container margin_top_1rem">
            <b-field label="Adjustment Function:">
                <b-select v-model="adjustmentFunctionName">
                    <option
                        v-for="adjustmentFunction in adjustmentFunctions"
                        :key="adjustmentFunction.name"
                        :value="adjustmentFunction.name"
                    >{{adjustmentFunction.name}}
                    </option>
                </b-select>
            </b-field>
            <b-field lable="Adjustment Arguments:" v-if="adjustmentFunctionName.length > 0 && adjustmentFunctionName !== 'none'">
                <b-input v-model="adjustmentFunctionArgs" placeholder="Arguments (optional)"></b-input>
            </b-field>
        </div>
        <div class="container margin_top_1rem buttons">
            <b-button type="is-danger" @click="handleDeleteRule">Delete Rule</b-button>
            <b-button type="is-success" @click="handleSaveChanges">Save Rule</b-button>
        </div>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BButton from "buefy/src/components/button/Button";
  import BField from "buefy/src/components/field/Field";
  import BSelect from "buefy/src/components/select/Select";
  import BIcon from "buefy/src/components/icon/Icon";
  import BInput from "buefy/src/components/input/Input";

  export default {
    components: {
      BInput,
      BIcon,
      BSelect,
      BField,
      BButton,
      BTableColumn
    },
    name: "prop-rule",
    props: ['objectId', 'data', 'actionTypes'],
    data() {
      return {
        addFormVisible: false,
        addSourceIntegrationId: 0,
        addSourceDeviceId: 0,
        addSourceTopicId: 0,
        initialCombineFunctionName: '',
        combineFunctionName: 'average',
        initialAdjustmentFunctionName: '',
        initialAdjustmentFunctionArgs: '',
        adjustmentFunctionName: 'none',
        adjustmentFunctionArgs: '',
        actionTypeId: 0
      };
    },
    computed: {
      ...mapGetters('devices', ['deviceTopics', 'devices', 'devicesByIntegrationId']),
      ...mapGetters('objects', ['combineFunctions', 'adjustmentFunctions']),
      ...mapGetters('integrations', ['integrations']),
      optionsForIntegration() {
        const ret = [
          {
            id: 0,
            name: 'Choose...'
          }
        ];

        this.integrations.forEach(item => {
          ret.push(item);
        });

        return ret;
      },
      optionsForDevice() {
        const ret = [
          {
            id: 0,
            name: 'Choose...'
          }
        ];

        this.devicesByIntegrationId(this.addSourceIntegrationId).forEach(item => {
          ret.push(item);
        });

        return ret;
      },
      topics() {
        const arr = [];

        if (this.data.parsed_rules) {
          this.data.parsed_rules.forEach(deviceTopicId => {
            const filtered = this.deviceTopics.filter(item => {
              return parseInt(item['id']) === parseInt(deviceTopicId);
            });

            if (filtered && filtered.length > 0) {
              arr.push(filtered[0]);
            }
          });
        }

        return arr;
      }
    },
    methods: {
      ...mapActions('objects', ['addSourceToPropRule', 'removePropRule', 'removeSourceFromPropRule', 'changePropRule']),
      topicsForDevice(deviceId) {
        return this.deviceTopics.filter(item => {
          return parseInt(item['device_id']) === parseInt(deviceId);
        });
      },
      validAdd() {
        return true;
      },
      handleAddSource() {
        this.addSourceToPropRule({
          id: this.objectId,
          deviceTopicId: this.addSourceTopicId
        });
        this.handleAbort();
      },
      resetFields() {
        this.addSourceTopicId = 0;
        this.addSourceDeviceId = 0;
      },
      handleAbort() {
        this.resetFields();
        this.addFormVisible = !this.addFormVisible;
      },
      handleSaveChanges() {
        this.changePropRule({
          id: parseInt(this.objectId),
          combineFunction: this.combineFunctionName,
          adjustmentFunction: this.adjustmentFunctionName,
          adjustmentArgs: this.adjustmentFunctionArgs
        });
      },
      handleDeleteRule() {
        // TODO: find confirmation method...
        if (confirm('Are you sure ?')) {
          this.removePropRule(this.objectId);
        }
      },
      handleDeleteSource(deviceTopicId) {
        if (confirm('Are you sure ?')) {
          this.removeSourceFromPropRule({
            id: this.objectId,
            deviceTopicId: deviceTopicId
          });
        }
      }
    },
    mounted() {
      this.initialCombineFunctionName = this.data.rules_combine;
      this.initialAdjustmentFunctionName = this.data.adjustment_function.length > 0 ? this.data.adjustment_function : 'none';
      this.initialAdjustmentFunctionArgs = this.data.adjustment_args;
      this.combineFunctionName = this.initialCombineFunctionName;
      this.adjustmentFunctionName = this.initialAdjustmentFunctionName;
      this.adjustmentFunctionArgs = this.initialAdjustmentFunctionArgs;
      this.actionTypeId = this.actionTypes[0].id;
    }
  }
</script>

<style scoped>
    .margin_top_1rem {
        margin-top: 1rem;
    }
</style>